import { useQuery } from '@tanstack/react-query'

import { API_ENDPOINTS } from '../../../common/apiEndpoints'
import { getInvitationResponseSchema } from '../../../common/validations/invitation'

import { get } from 'api/apiClient'

export const useAPIGetInvitation = (uuid: string) => {
  const path = API_ENDPOINTS.INVITATION.replace(':uuid', uuid)

  return useQuery({
    queryKey: [path],
    queryFn: () => get(path, getInvitationResponseSchema),
    // Fetching the invitation resends the verification code as a side effect
    // when registration is already started, so it must run only once per
    // invitation page visit.
    staleTime: Infinity,
    refetchOnWindowFocus: false,
    retry: false,
  })
}
